const isValidNestedObject = (
  rawTokens: string | object
): rawTokens is object => {
  return (
    typeof rawTokens === 'object' &&
    !Array.isArray(rawTokens) &&
    rawTokens !== null
  );
};

export const getValue = (rawTokens: object, tokenName: string): string => {
  const keys = tokenName.split('.');
  let current: object | string = rawTokens;

  for (const key of keys) {
    if (isValidNestedObject(current) && current?.hasOwnProperty(key)) {
      current = current[key as keyof object] as object | string;
    } else {
      return '';
    }
  }

  return current as string;
};
